import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-jjsv-banner',
  imports: [],
  templateUrl: './jjsv-banner.component.html',
  styleUrl: './jjsv-banner.component.scss',
})
export class JjsvBanner {
  @Input() content: { title: string; subtitle: string; imageUrl?: string } = { title: '', subtitle: '' };
}
